/**
 * Open-Iti Imports business service
 */
angular.module("exploitation").factory("OpenImportsService", [
	"$http", "ENV", "$interval", "$rootScope", "CONSTANTS", "toastr",
	function ($http, ENV, $interval, $rootScope, CONSTANTS, toastr) {


	/**
	 * API
	 */
	var api = {
		getAllImports: getAllImports,
		getAllImportsWithJobResult: getAllImportsWithJobResult,
		getMobiitiImports: getMobiitiImports,
		getLatestMobiitiImport: getLatestMobiitiImport,
		deleteImport: deleteImport,
		postImport: postImport,
		postAnalyze: postAnalyze,
		postReimport: postReimport,
		postNeptuneImport: postNeptuneImport,
		postNetexImport: postNetexImport,
		getImportDataFile: getImportDataFile,
		getMobiitiImportDataFile: getMobiitiImportDataFile,
		getActionReport: getActionReport,
		getAnalysisReport: getAnalysisReport,
		getActionParameters: getActionParameters,
		getValidationReport: getValidationReport,
		getImport: getImport,
		getGtfsFlexImportJob: getGtfsFlexImportJob,
		getImportedFiles: getImportedFiles,
		getOkinaJobStatus: getOkinaJobStatus,
		feedImportData: feedImportData,
		getReportDetails: getReportDetails,
		importPredefinedImport: importPredefinedImport,

		okinaJobStatusChecker: okinaJobStatusChecker,
		validate: validate,
		getAllActiveOperatorCompanies: getAllActiveOperatorCompanies,
		jobCheckerFunctions: {}

	};


	function okinaJobStatusChecker(referential, jobId) {
		if (!api.jobCheckerFunctions[jobId]) {
			api.jobCheckerFunctions[jobId] = $interval(function () {
				getOkinaJobStatus(jobId).then((response) => {
					const status = response.data;
					if (status === "TERMINATED") {
						$interval.cancel(api.jobCheckerFunctions[jobId]);
						$rootScope.$broadcast(CONSTANTS.EVENT_IMPORT_COMPLETE);
						toastr.success("<a href=\"#/data-management/imports/" + referential + "/" + jobId + "\">Cliquez ici pour accéder au résultat de l'import</a>", "Import terminé", {allowHtml: true});
						api.jobCheckerFunctions[jobId] = undefined;
					} else if (status === "ABORTED") {
						$interval.cancel(api.jobCheckerFunctions[jobId]);
						$rootScope.$broadcast(CONSTANTS.EVENT_IMPORT_COMPLETE);
						toastr.error("<a href=\"#/data-management/imports/" + referential + "/" + jobId + "\">Cliquez ici pour accéder au résultat de l'import</a>", "Import terminé - problèmes lors de l'import.", {allowHtml: true});
						api.jobCheckerFunctions[jobId] = undefined;
					}

				});
			}, 5000);
		}
	}


	/**
	 * Récupérer le statut d'un job Okina.
	 * Job okina englobe job IEV + actions sépcifiques Okina (MAJ BDD) suite à l'import.
	 * @param jobId
	 */
	function getOkinaJobStatus(jobId) {
		return $http.get(ENV.API_URL + "/imports/" + jobId + "/okinaJobStatus");
}

	/**
	 * Récupérer le fichier d'import pour un job.
	 * @param referential
	 * @param jobId
	 * @param fileName
	 * @returns {*}
	 */
	function getImportDataFile(referential, jobId, fileName) {
		return $http.get(ENV.API_URL + "/imports/" + referential + "/" + jobId + "/data/" + fileName, {
			responseType: "arraybuffer",
			headers: {
				"Content-Type": "application/octet-stream"
			}
		});
	}

	function getMobiitiImportDataFile(refId, fileName) {
		return $http.get(ENV.TIMETABLE_ADMIN_BASE_URL + refId + "/files/" + fileName, {
			responseType: "arraybuffer",
			headers: {
				"Content-Type": "application/octet-stream"
			}
		});
	}

	/**
	 * Récupérer le rapport d'action pour un job
	 * @param referential
	 * @param jobId
	 * @returns {*}
	 */
	function getActionReport(referential, jobId) {
		return $http.get(ENV.IEV_URL + "/referentials/" + referential + "/data/" + jobId + "/action_report.json");
	}

	/**
	 * Récupérer le rapport d'analyse pour un job
	 * @param referential
	 * @param jobId
	 * @returns {*}
	 */
	function getAnalysisReport(referential, jobId) {
		return $http.get(ENV.IEV_URL + "/referentials/" + referential + "/data/" + jobId + "/analysis_report.json");
	}


	/**
	 * Récupérer les paramètres d'un job
	 * @param referential
	 * @param jobId
	 * @returns {*}
	 */
	function getActionParameters(referential, jobId) {
		return $http.get(ENV.IEV_URL + "/referentials/" + referential + "/data/" + jobId + "/action_parameters.json");
	}


	/**
	 * Récupérer le rapport de validation pour un job
	 * @param referential
	 * @param jobId
	 * @returns {*}
	 */
	function getValidationReport(referential, jobId) {
		return $http.get(ENV.API_URL + "/imports/" + referential + "/" + jobId + "/validation_report.json");
	}

	/**
	 * Récupérer le détail d'un import.
	 * @param referential
	 * @param jobId
	 * @returns {*}
	 */
	function getImport(referential, jobId) {
		return $http.get(ENV.API_URL + "/imports/" + referential + "/" + jobId);
	}

	/**
	 * Récupérer le détail d'un job d'import GTFS-Flex (Uttu).
	 * @param jobId
	 * @returns {*}
	 */
	function getGtfsFlexImportJob(jobId) {
		return $http.get(ENV.FLEX_BASE_URL + "job/" + jobId);
	}

	/**
	 * Récupérer la liste des fichiers importés.
	 * @param refId
	 * @returns {*}
	 */
	function getImportedFiles(refId) {
		return $http.get(ENV.TIMETABLE_ADMIN_BASE_URL + refId + "/files", {
			transformRequest: angular.identity,
			headers: {
				"Content-Type": undefined
			}
		});
	}

	/**
	 * Récupérer tous les imports
	 *
	 * @returns {*}
	 */
	function getAllImports() {
		return $http.get(ENV.API_URL + "/imports");
	}

	function getAllImportsWithJobResult() {
		return $http.get(ENV.API_URL + "/imports/with-job-result");
	}

	function getMobiitiImports(refId) {
		return $http.get(ENV.EVENTS_BASE_URL + "timetable/" + refId, {
			transformRequest: angular.identity,
			headers: {
				"Content-Type": undefined
			}
		});
	}

	function getLatestMobiitiImport(refId) {
		return $http.get(ENV.EVENTS_BASE_URL + "timetable/" + refId
			+ "?actionType=IMPORTER&action=FILE_TRANSFER&action=FILE_CLASSIFICATION&action=IMPORT&latest=true", {
			transformRequest: angular.identity,
			headers: {
				"Content-Type": undefined
			}
		});
	}

	/**
	 * Démarrer un job d'import.
	 * @param type
	 * @param importData
	 * @param refId
	 * @param user
	 * @returns {*}
	 */
	function postImport(type, importData, refId, user) {
		return postFileToTimeTableAdmin(type, importData, refId, user, "files");
	}

	/**
	 * Démarrer un job d'analyse de fichier
	 * @param importData
	 * @param refId
	 * @param user
	 * @returns {*|HttpPromise}
	 */
	function postAnalyze(type, importData, refId, user) {
		return  postFileToTimeTableAdmin(type, importData, refId, user, "analyzeFile");
	}



	function postFileToTimeTableAdmin(type, importData, refId, user, action) {
		let fd = new FormData();
		fd.append("file", importData.file);
		let formattedDescription = "";
		if ( importData.description != null &&  importData.description !== undefined){
			formattedDescription =  importData.description.replace("\n","\\n")
		}
		return $http.post(ENV.TIMETABLE_ADMIN_BASE_URL + refId + "/" + action, fd, {
			responseType: "blob",
			transformRequest: angular.identity,
			// Marduk expects the original file name as a query param (RutebankenFileName) for GTFS-Flex-only imports
			params: importData.gtfsFlexOnly ? {RutebankenFileName: importData.fileName} : undefined,
			headers: {
				"Accept": "text/html",
				"Content-Type": undefined,
				"RutebankenDescription":formattedDescription,
				"RutebankenUser": user,
				"ImportType": type,
				"routeMerge": importData.routeMerge,
				"generateMapMatching" : importData.generateMapMatching,
				"routesReorganization" : importData.routesReorganization,
				"routeSortOrder": importData.routeSortOrder,
				"netexImportLayouts": importData.netexImportLayouts,
				"netexImportColors": importData.netexImportColors,
				"splitCharacter": importData.splitCharacter,
				"commercialPointIdPrefixToRemove": importData.commercialPointIdPrefixToRemove,
				"areaCentroidPrefixToRemove": importData.areaCentroidPrefixToRemove,
				"linePrefixToRemove": importData.linePrefixToRemove,
				"stopAreaPrefixToRemove": importData.stopAreaPrefixToRemove,
				"quayIdPrefixToRemove": importData.quayIdPrefixToRemove,
				"cleanMode": importData.cleanMode,
				"ignoreCommercialPoints": importData.ignoreCommercialPoints,
				// GTFS-Flex-only files never get a Chouette analysis job: identify them by fileName instead (see params above)
				"analysisJobId" : importData.gtfsFlexOnly ? undefined : importData.analysisJobId,
				"gtfsFlexOnly": importData.gtfsFlexOnly ? true : undefined,
				"keepBoardingAlightingPossibility" : importData.keepBoardingAlightingPossibility,
				"keepStopGeolocalisation" : importData.keepStopGeolocalisation,
				"keepStopNames" : importData.keepStopNames,
				"removeParentStations" : importData.removeParentStations,
				"importShapesFile" : importData.importShapesFile,
				"updateStopAccessibility" : importData.updateStopAccessibility,
				"railUICprocessing" : importData.railUICprocessing,
				"distanceGeolocation" : importData.distanceGeolocation,
				"useTargetNetwork": importData.useTargetNetwork,
				"targetNetwork":  importData.targetNetwork,
				"renameRoutesAfterMerge": importData.renameRoutesAfterMerge,
				"importFareFiles": importData.importFareFiles,
				"recomputeStopPlacesLocation": importData.recomputeStopPlacesLocation,
				"importTargetRoutes": importData.importTargetRoutes,
				"allowNonStandardGtfs": importData.allowNonStandardGtfs,
				"fillMissingStopName": importData.fillMissingStopName,
				"fillMissingCoordinates": importData.fillMissingCoordinates,
				"overwriteLineInformation": importData.overwriteLineInformation,
				"allowGtfsFlex": importData.allowGtfsFlex,
				"externalRefField": importData.externalRefField,
				"driverControllerCodeField": importData.driverControllerCodeField,
			}
		});
	}


	/**
	 * Relancer un job d'import sur un fichier déjà importé.
	 * @param fileName
	 * @param refId
	 * @param user
	 * @param user
	 * @param description
	 * @returns {*}
	 */
	function postReimport(fileName, refId, user, description) {

		return $http.post(ENV.TIMETABLE_ADMIN_BASE_URL + refId + "/import", {
				files: [
					{
						name: fileName
					}
				]
			},
			{
				headers: {
					"Accept": "application/json",
					"Content-Type": "application/json",
					"RutebankenUser": user,
					"RutebankenDescription": description ? description : ""
				}
			});

	}

	/**
	 * Démarrer un job d'import Neptune.
	 * @param importData
	 * @returns {*|HttpPromise}
	 */
	function postNeptuneImport(importData) {

		var fd = new FormData();
		fd.append("file", importData.file);
		fd.append("name", importData.name);
		return $http.post(ENV.API_URL + "/imports/neptune", fd, {
			transformRequest: angular.identity,
			headers: {"Content-Type": undefined}
		});

	}


	/**
	 * Démarrer un job d'import Netex.
	 * @param importData
	 * @returns {*|HttpPromise}
	 */
	function postNetexImport(importData) {

		var fd = new FormData();
		fd.append("file", importData.file);
		fd.append("name", importData.name);
		return $http.post(ENV.API_URL + "/imports/netex", fd, {
			transformRequest: angular.identity,
			headers: {"Content-Type": undefined}
		});

	}


	/**
	 * Supprimer un import.
	 *
	 * @returns {*}
	 */
	function deleteImport(importToDelete) {
		return $http.delete(ENV.API_URL + "/imports/" + importToDelete.referential + "/" + importToDelete.id);
	}

	function validate(providerId, user) {
		return $http.post(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/validate", {
			headers: {
				"Content-Type": "application/json",
				Accept: 'application/json',
				"RutebankenUser": user
			}
		});
	}

	function importPredefinedImport(providerId, user, importConfigurationId) {
		return $http.post(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/import/" + importConfigurationId, {
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				"RutebankenUser": user,
			}
		});
	}

	function feedImportData(importData, client){
		if(!importData.routesReorganization){
			importData.routesReorganization = client.routesReorganization;
		}
		if(!importData.routeSortOrder){
			importData.routeSortOrder = client.routeSortOrder;
		}
		if(!importData.netexImportLayouts){
			importData.netexImportLayouts = client.netexImportLayouts;
		}
		if(!importData.netexImportColors) {
			importData.netexImportColors = client.netexImportColors;
		}
		return importData;
	}

	function getReportDetails(){
		return $http.get(ENV.API_URL + "/imports/report-details");
	}

	function getAllActiveOperatorCompanies(){
		return $http.get(ENV.API_URL + "/companies?active=true&organisationType=Operator");
	}

	return api;
}]);
